import styled from "@emotion/styled";
import { Box } from '@mui/material';
import Typography from "@mui/material/Typography";


export const LinkStyled = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex;
`;

export const TypographyStyled = styled(Typography)`
  margin-top: 0px;
`;
